import ProductDetail from './components/ProductDetail';

const ProductDetailPage = () => {
  return <ProductDetail />;
};

export default ProductDetailPage;
